/** Pairing-code alphabet shared with the server (no 0/O/1/I so codes read aloud without mistakes). */
export const CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
